import createReducer from '../../utils/createReducer';

const initialState = {
  locale: 'en'
};

export default createReducer(initialState, {});
